import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import CreateUser from "@/features/users/create";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/users/create")({
  component: RouteComponent,
  validateSearch: z.object({
    "project-id": z.coerce.number().positive().optional(),
  }),
});

function RouteComponent() {
  usePageTitle("Create User");

  return <CreateUser />;
}
